import * as r from 'ramda';
import * as ra from 'ramda-adjunct';
import { createSelector } from 'reselect';

const getUserProfileBase = r.prop('userProfile');

export const getUserProfileRaw = r.pipe(getUserProfileBase, r.prop('profile'));

export const getUserProfile = createSelector(
  getUserProfileRaw,
  r.when(
    ra.isNotNil,
    r.pipe(
      r.prop('Data'),
      ra.renameKeys({
        Name: 'name',
        Title: 'title',
        Description: 'description',
        Labels: 'tags',
        // TODO: Convert this into array
        FbUrl: 'socialLinks.facebook',
        instaUrL: 'socialLinks.instagram',
        WebsiteUrl: 'socialLinks.website',
        CoverPhotoURL: 'coverPhotoUrl',
        ProfilePhotoURL: 'profilePhotoUrl',
        CustomSettings: 'customSettings',
        PromotionLayouts: 'promotionLayouts',
      }),
      r.evolve({
        tags: (tagsString) => tagsString.split(',').filter((value) => value),
      })
    )
  )
);

export const getUserProfileId = r.pipe(getUserProfileBase, r.prop('profile'), r.propOr(null, 'Id'));

export const getUserProfileName = createSelector(getUserProfile, r.prop('name'));

export const getTempCoverPhotoUrl = r.pipe(getUserProfileBase, r.prop('tempCoverPhotoUrl'));

export const getTempProfilePhotoUrl = r.pipe(getUserProfileBase, r.prop('tempProfilePhotoUrl'));
